import { get } from "@/js/request.js";
import "@/css/NewsDetail/index.css";
import day from "dayjs";
import { getQuery } from "@/js/utils.js";
import en from "@/locales/en.json";
import zhCN from "@/locales/zh-CN.json";
import zh from "@/locales/zh.json";

function updatePageByLanguage(lang) {
  const langDataMap = {
    en: en,
    "zh-CN": zhCN,
    default: zh,
  };
  const currentLangData = langDataMap[lang] || langDataMap.default;
  const paramsObj = getQuery("id");
  const currentStory = currentLangData.story?.[paramsObj.id];

  if (!currentStory) return;

  const title = document.querySelector(".new-title");
  const content = document.querySelector(".content");
  const date = document.querySelector(".new-date");
  const sendDate = document.querySelector(".sendDate");

  title.innerHTML = currentStory.title;
  document.title = currentStory.title;
  content.innerHTML = currentStory.htmlDesc;
  date.innerHTML = currentStory.time;
  sendDate.innerHTML = `发布时间：${currentStory.time}`;

  sendDate.classList.remove("none");
  document.getElementById("loading")?.classList.remove("active");
}

function getNormalizedLanguage() {
  const storedLanguage = localStorage.getItem("preferred-language");
  return storedLanguage === "null" || storedLanguage === null
    ? "zh-CN"
    : storedLanguage;
}

(function overrideLocalStorageSetItem() {
  const originalSetItem = localStorage.setItem;

  localStorage.setItem = function (key, value) {
    if (key === "preferred-language") {
      const oldValue = localStorage.getItem(key);
      const newValue = value;
      if (oldValue !== newValue) {
        console.log("当前页面语言已更新为：", newValue);
        updatePageByLanguage(newValue);
      }
    }

    originalSetItem.call(this, key, value);
  };
})();

const initLang = getNormalizedLanguage();
updatePageByLanguage(initLang);
// get("/journalism/detail", paramsObj, (res) => {
//   title.innerHTML = res.data.title;
//   document.title = `${res.data.title} - 少伯健康`;
//   content.innerHTML = res.data.content;
//   date.innerHTML = day(res.data.createDate * 1000).format(
//     "YYYY-MM-DD HH:mm:ss"
//   );
//   sendDate.innerHTML = `发布时间：${day(res.data.createDate * 1000).format(
//     "YYYY-MM-DD HH:mm:ss"
//   )}`;
//   sendDate.classList.remove("none");
//   let scrollHeight = document.documentElement.scrollHeight;
//   let clientHeight = document.documentElement.clientHeight;

//   window.addEventListener("scroll", () => {
//     const height = scrollHeight - clientHeight;
//     const scrollTop =
//       document.body.scrollTop || document.documentElement.scrollTop;
//     textLoader.style.width = `${(scrollTop / height) * 100}%`;
//   });
// });
